import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=6e993f38&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=6e993f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e993f38",
  null
  
)

export default component.exports